import React, { Component } from 'react';

//Other Helpers
import BlurImageLoader from 'react-blur-image-loader'
import {Link} from 'react-router-dom';

class ProductNode extends Component {
    

    render() {
        let specs = [];

        if (this.props.loading !== 'loading') {
            for( let i = 0; i < this.props.item.specifications.length && i < 5; i++) {
                specs.push(
                    <div className="spec" key={i}>
                        {this.props.item.specifications[i].spec_name} : {this.props.item.specifications[i].spec_value}
                    </div>
                )
            }
        }
        
        return (
            <div className={this.props.loading ? 'product-wrapper ' + this.props.loading : 'product-wrapper'} >
                
                {
                    this.props.loading === 'loading' ? 
                        <img src="./images/icon.png" />
                    :  

                    <BlurImageLoader src={ this.props.item.cloudinary_path + 'c_fill,h_500,q_100,w_500/' + this.props.item.thumb_image_id  } 
                        preview={this.props.item.cloudinary_path + 'c_fill,h_10,q_10,w_10/' + this.props.item.thumb_image_id }
                        fullCover={true}
                        maxBlurLevel={10}
                        transitionTime={400} />
                        
                        
                }
                
                <span className="starts-from">
                    {
                        this.props.loading === 'loading' ? 
                            <span className="strap"></span>
                        : (
                            <span>
                                <s>DKK{this.props.item.strike_price}</s> - DKK{this.props.item.final_price}
                            </span>
                        )
                            
                    }
                </span>
                
                <div className="specifications">
                    
                    <h2>
                        {
                            this.props.loading === 'loading' ? 
                                <span className="strap"></span>
                            : 
                                this.props.item.title                            
                                
                        }
                    </h2>

                    <div className="more">
                        {specs}
                    </div>
                </div>
                
                {
                    this.props.loading === 'loading' 
                        ? null 
                        : (
                            this.props.item.acc_id
                                ? <Link className="link" to={'accessory/' + this.props.item.page_uri} ></Link>
                                : <Link className="link" to={'cycle/' + this.props.item.page_uri} ></Link>
                        )
                }
                

            </div>
        );
    }
}

export default ProductNode;



// WEBPACK FOOTER //
// ./src/Reducer/ProductNode.js